export default "mdc-text-field {\n  width: 100%;\n  border-radius: 0;\n}"